import { render, staticRenderFns } from "./PoweredBySnippet.vue?vue&type=template&id=535b4180&scoped=true"
import script from "./PoweredBySnippet.vue?vue&type=script&lang=js"
export * from "./PoweredBySnippet.vue?vue&type=script&lang=js"
import style0 from "./PoweredBySnippet.vue?vue&type=style&index=0&id=535b4180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b4180",
  null
  
)

export default component.exports